import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { InteractiveButton } from '../..';
import IDHelpers from '../../../../../../core/helpers/IDHelper';
import { Block, Text, Icon } from '../../../../../components';
import StatusRequest from './Status';
import clockIcon from '../../../../../../assets/icons/icon-clock-black.svg';
import calendarIcon from '../../../../../../assets/icons/icon-calendar.svg';
import { UtpButton } from '../../../modules/scholarships/bse/home/Components/bseStyle';
import routes from '../../../../../components/Routes/routingMap';
import constants from '../../../constants';

interface CardRequestProps {
  myProcedure: any;
  handleClick: (requestId: number, procedureId: number) => void;
  tabIndexButton: number;
}

const getProcedureDate = (myProcedure: any, key: string) =>
  [
    ...constants.categories.certificates.type1Ids,
    1013,
    1032,
    1036,
    1038
  ].includes(myProcedure.procedureId) &&
  (myProcedure.status.description === 'Por pagar' ||
    myProcedure.status.description === 'Activar pago' ||
    myProcedure.status.description === 'Anulado por falta de pago')
    ? ' - '
    : myProcedure[key]?.toLowerCase();

const renderDateMessage = (myProcedure: any) => {
  // Si status.description es "Por atender en UTP"
  if (
    [
      ...constants.categories.certificates.type1Ids,
      1013,
      1032,
      1036,
      1038
    ].includes(myProcedure.procedureId) &&
    (myProcedure.status.description === 'Por pagar' ||
      myProcedure.status.description === 'Activar pago' ||
      myProcedure.status.description === 'Anulado por falta de pago')
  ) {
    return 'Fecha estimada de respuesta: -';
  }

  if (
    myProcedure.status.name === 'Pendiente' &&
    myProcedure.duration === 'Inmediato'
  ) {
    return '';
  }

  // Si realEndDate existe y no está vacío
  if (myProcedure.realEndDate) {
    return `Fecha de respuesta: ${myProcedure.realEndDate}`;
  }

  // Si estimatedEndDate existe y no está vacío
  if (myProcedure.estimatedEndDate) {
    return `Fecha estimada de respuesta: ${myProcedure.estimatedEndDate}`;
  }
  if (
    myProcedure.duration === 'Inmediato' &&
    myProcedure.status.description === 'Procede'
  ) {
    return `Fecha de respuesta: ${myProcedure.realEndDate?.toLowerCase()}`;
  }

  return null; // Retornar null o algún valor predeterminado si ninguna condición se cumple
};

export const ViewDetails = (myProcedure: any, isNotRegistered?: boolean) => (
  <>
    <Block
      customized
      flexDirection="row"
      alignItems="center"
      margin={isNotRegistered ? '0px 0px 20px 0px' : '0px'}
    >
      <Icon customized maxWidth="13.33px" margin="0px 5.33px 0px 0px">
        <img src={calendarIcon} alt="" />
      </Icon>
      <Text color="#161D1F" fontSize="12px" lineHeight="20px" fontWeight="400">
        Fecha de solicitud: {getProcedureDate(myProcedure, 'startDate')}
      </Text>
    </Block>
    {renderDateMessage(myProcedure) ? (
      <Block customized flexDirection="row" alignItems="center">
        <Icon customized maxWidth="13.33px" margin="0px 5.33px 0px 0px">
          <img src={calendarIcon} alt="other" />
        </Icon>
        <Text
          color="#161D1F"
          fontSize="12px"
          lineHeight="20px"
          fontWeight="400"
        >
          {renderDateMessage(myProcedure)}
        </Text>
      </Block>
    ) : (
      <br />
    )}
  </>
);

const CardRequest = (props: CardRequestProps) => {
  const { myProcedure, handleClick, tabIndexButton } = props;
  const { procedureId } = myProcedure;
  const hasInteraction = procedureId !== -9999;
  const isNotRegistered =
    procedureId === 1017 && myProcedure.status.description === 'No registrado';
  const history = useHistory();
  const goToRegisterTicket = () => {
    const paramSendDocs = 'TA0047';
    history.push(
      `${routes.student.procedures.categories.tickets.register}?v=${paramSendDocs}`
    );
  };
  return (
    <Block
      data-testid="cmp-card-request"
      className="wrapSummary"
      key={IDHelpers.generateID()}
    >
      <InteractiveButton
        bkgColorEnabled="#ffffff"
        bkgColorHover="#E2DFFD"
        bkgColorFocus="#C6C0FC"
        bkgColorPressed="#C6C0FC"
        minWidth="264px"
        customized
        onClick={handleClick}
        maxWidth="264px"
        backgroundColor="#fff"
        borderRadius="8px"
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        shadow="0px 2px 8px -4px rgba(176, 192, 202, 0.4)"
        hasInteraction={hasInteraction && !isNotRegistered}
        height="187px"
        tabIndexButton={hasInteraction && !isNotRegistered ? tabIndexButton : 0}
      >
        <Block padding="12px" customized>
          <Block
            customized
            flexDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            margin="0px 0px 4px 0px"
          >
            <Text
              color="#161D1F"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="900"
              className="titleProcedure"
            >
              {myProcedure.name}
            </Text>
          </Block>
          {myProcedure.procedureId === -9999 ? (
            <>
              {' '}
              <Block customized flexDirection="row" alignItems="center">
                <Icon customized maxWidth="13.33px" margin="0px 5.33px 0px 0px">
                  <img src={clockIcon} alt="" />
                </Icon>
                <Text
                  color="#161D1F"
                  fontSize="12px"
                  lineHeight="20px"
                  fontWeight="400"
                >
                  {myProcedure.duration}
                </Text>
              </Block>
              {ViewDetails(myProcedure)}
            </>
          ) : (
            <>
              {!isNotRegistered && (
                <Block customized flexDirection="row" alignItems="center">
                  <Icon
                    customized
                    maxWidth="13.33px"
                    margin="0px 5.33px 0px 0px"
                  >
                    <img src={clockIcon} alt="" />
                  </Icon>
                  <Text
                    fontSize="12px"
                    color="#161D1F"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    {myProcedure.duration}
                  </Text>
                </Block>
              )}
              {ViewDetails(myProcedure, isNotRegistered)}
            </>
          )}
        </Block>
        <Block customized height="1px" width="100%" backgroundColor="#D5E5F0" />
        <Block customized padding="12px">
          <Block customized flexDirection="row" margin="0px 0px 8px 0px">
            <StatusRequest
              {...myProcedure.status}
              procedureId={myProcedure.procedureId}
            />
          </Block>
          {!hasInteraction && (
            <Text fontSize="12px">
              *Revisa el detalle
              <UtpButton
                data-testid="cmp-utpbutton-card"
                className="Urlcolor link-underline"
                tabIndex={tabIndexButton}
                href={process.env.REACT_APP_OUTLOOK_URL}
                target="_blank"
              >
                en tu correo
              </UtpButton>
            </Text>
          )}
          {isNotRegistered && (
            <Text fontSize="12px">
              Reporta el inconveniente en
              <UtpButton
                data-testid="cmp-utpbutton-card"
                className="Urlcolor link-underline"
                tabIndex={tabIndexButton}
                onClick={() => goToRegisterTicket()}
              >
                registro de quejas y reclamos.
              </UtpButton>
            </Text>
          )}
        </Block>
      </InteractiveButton>
    </Block>
  );
};

export default CardRequest;
